var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#D6F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40002259_101376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4114 15.3335H14.7382C15.5047 15.3335 16.1145 14.9842 16.6619 14.4959C18.0527 13.2552 14.7834 12.0002 13.6673 12.0002M12.334 5.37934C12.4854 5.34931 12.6426 5.3335 12.8038 5.3335C14.0171 5.3335 15.0007 6.22893 15.0007 7.3335C15.0007 8.43807 14.0171 9.3335 12.8038 9.3335C12.6426 9.3335 12.4854 9.31768 12.334 9.28765",
    stroke: "#3174C7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98754 12.741C4.20156 13.1622 2.14076 14.0222 3.39592 15.0984C4.00906 15.6242 4.69194 16.0002 5.55048 16.0002H10.4495C11.3081 16.0002 11.9909 15.6242 12.6041 15.0984C13.8592 14.0222 11.7984 13.1622 11.0125 12.741C9.16934 11.7532 6.83066 11.7532 4.98754 12.741Z",
    stroke: "#3174C7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.00016C10.6667 8.47292 9.47276 9.66683 8 9.66683C6.52724 9.66683 5.33333 8.47292 5.33333 7.00016C5.33333 5.5274 6.52724 4.3335 8 4.3335C9.47276 4.3335 10.6667 5.5274 10.6667 7.00016Z",
    stroke: "#3174C7",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40002259_101376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomer);
export default __webpack_public_path__ + "static/media/icon-customer.5d4bbb79b6ed2f145802038cfaa611e0.svg";
export { ForwardRef as ReactComponent };